import React from 'react';

export const ServiceReviewContext = React.createContext();
export const ServiceReviewContextProvider = ServiceReviewContext.Provider;